<template>
  <div class="text-center uppercase text-title font-medium">
    {{ forgotAction ? "Forgot Password" : "Sign In" }}
  </div>
  <div class="flex items-center justify-center pt-10">
    <div class="w-full px-6 md:w-4/6 lg:w-3/6 2xl:w-1/3">
      <form class="space-y-8 text-content" ref="authForm" @submit.stop="submit">
        <div :class="{ error: v$.form.email.$errors.length }">
          <label for="">Email</label>
          <input
            type="text"
            ref="email"
            v-model="v$.form.email.$model"
            class="w-full px-0 pt-2 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
          />
          <div
            class="input-errors"
            v-for="(error, index) of v$.form.email.$errors"
            :key="index"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>

        <div
          v-if="!forgotAction"
          :class="{ error: v$.form.password.$errors.length }"
        >
          <label for="">Password</label>
          <input
            type="password"
            ref="password"
            v-model="v$.form.password.$model"
            class="w-full px-0 pt-2 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
          />
          <div
            class="input-errors"
            v-for="(error, index) of v$.form.password.$errors"
            :key="index"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
        <div class="text-left text-n3yellow mt-[-10px]">
          <a
            href="javascript:void(0)"
            @click.prevent="
              (forgotAction = !forgotAction), $refs.authForm.reset()
            "
          >
            {{ forgotAction ? "Sign in" : "Forgot your password?" }}
          </a>
        </div>

        <div class="text-center pt-10">
          <default-button
            :disable="
              processing ||
              !!v$.form.email.$errors.length ||
              !v$.form.email.$model
            "
            :loading="processing"
            :label="
              processing ? 'Loading...' : forgotAction ? 'Send' : 'Sign In'
            "
            classes="w-full sm:w-3/6"
            @clicked="submit"
          />

          <div class="text-content">
            <div v-if="!forgotAction">
              <div class="my-5">
                Don't have an account?
                <a
                  href=""
                  @click.prevent="$router.push({ name: 'register' })"
                  class="text-n3yellow"
                  >Sign up</a
                >
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import DefaultButton from "@/components/button/DefaultButton.vue";
import { getStorage, removeStorage } from "@/utils/helper";
import { mapActions, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import { useMeta } from "vue-meta";
import { useSweetAlert } from "@/composable/useSweetAlert";
export default {
  components: { DefaultButton },
  name: "SignIn",
  setup() {
    useMeta({ title: "Sign In" });
    return { v$: useVuelidate() };
  },
  data: function () {
    return {
      form: {
        email: "",
        password: "",
      },

      passwordFieldicon: "password",
      visibility: false,
      visibilityIcon: "visibility",
      forgotAction: false,
    };
  },
  validations() {
    return {
      form: {
        email: {
          required,
          email,
        },
        password: {
          required,
        },
      },
    };
  },

  computed: {
    ...mapGetters("auth", [
      "currentUser",
      "processing",
      "loginError",
      "forgotMailSuccess",
    ]),
    ...mapGetters("form", ["$errors"]),
  },
  watch: {
    currentUser(val) {
      if (val && val.uid) {
        setTimeout(() => {
          const lastRequested = getStorage("REDIRECT_TO") || "/";
          removeStorage("REDIRECT_TO");
          this.$router.push(lastRequested);
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions("auth", ["login", "forgotPassword"]),
    ...mapActions("reservation", ["setState"]),

    switchVisibility() {
      this.visibility = !this.visibility;
      this.passwordFieldType = this.visibility ? "text" : "password";
      this.visibilityIcon = this.visibility ? "visibility_off" : "visibility";
    },

    submit() {
      const { Toast } = useSweetAlert();

      if (!this.forgotAction) {
        this.login(this.form).catch((msg) => {
          Toast.fire({
            title: msg,
            icon: "warning",
          });
        });
      } else {
        if (!this.v$.form.email.$errors.length) {
          this.forgotPassword({
            email: this.form.email,
          })
            .then(() => {
              this.form.email = "";
              this.v$.form.$reset();
              Toast.fire({
                title: "Reset email has been sent",
                icon: "success",
              });

              this.forgotAction = false;
            })
            .catch((e) => {
              Toast.fire({
                title: e,
                icon: "warning",
              });
            });
        }
      }
    },
  },
};
</script>
